import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgFacebook = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		fillRule: "evenodd",
		d: "M18.041 1h-16C1.473 1 1 1.471 1 2.037v15.926C1 18.53 1.473 19 2.041 19h8.616v-6.974H8.29V9.293h2.367V7.314c0-2.356 1.42-3.581 3.503-3.581.946 0 1.798.094 2.082.094v2.45h-1.42c-1.136 0-1.325.566-1.325 1.32v1.696h2.65l-.378 2.733h-2.367V19h4.544c.569 0 1.042-.471 1.042-1.037V2.037C19.083 1.47 18.609 1 18.04 1z"
	})
});
export default SvgFacebook;
